angular.module('NaviaqWebApp').directive('activityLineImage', [function () {
    'use strict';

    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'app/report/directives/activity-line-image.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
